import { render } from "./JobDeatils.vue?vue&type=template&id=c8ee1a70&scoped=true"
import script from "./JobDeatils.vue?vue&type=script&lang=js"
export * from "./JobDeatils.vue?vue&type=script&lang=js"

import "./JobDeatils.vue?vue&type=style&index=0&id=c8ee1a70&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8ee1a70"]])

export default __exports__